// Render fragment for of — the entity's GraphQL display contract.
// Scaffolded once from the @medplum/definitions reverse projection; hand-curate
// freely to match what the view renders (this file is owned, not generated).
import { graphql } from '@eluve/graphql-fhir';

/**
 * Everything a Practitioner view (or the generic fallback) could render.
 * Compose into queries: graphql(`query { ... ...PractitionerRender }`, [PractitionerRenderFragment]).
 * References are terminal ({ reference type display }) — expand nested
 * `resource` selections in the query when resolved targets are needed.
 */
export const PractitionerRenderFragment = graphql(`
  fragment PractitionerRender on Practitioner @_unmask {
    resourceType
    id
    meta {
      versionId
      lastUpdated
      profile
      tag {
        system
        code
      }
      security {
        system
        code
        display
      }
    }
    modifierExtension {
      url
    }
    identifier {
      use
      system
      value
    }
    active
    name {
      use
      text
      family
      given
      prefix
      suffix
    }
    telecom {
      system
      value
      use
    }
    address {
      use
      type
      text
      line
      city
      district
      state
      postalCode
      country
    }
    gender
    birthDate
    photo {
      contentType
      url
      title
      creation
    }
    qualification {
      identifier {
        use
        system
        value
      }
      code {
        text
        coding {
          system
          code
          display
        }
      }
      period {
        start
        end
      }
      issuer {
        reference
        type
        display
      }
    }
    communication {
      text
      coding {
        system
        code
        display
      }
    }
  }
`);
